import { useEffect, useRef } from "react";
import { toast } from "sonner";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

// Mounted once. When Chrome/Android signals the app is installable, show a single
// gentle "Install" toast so users who expect an automatic prompt get one.
export const InstallPrompter = () => {
  const deferred = useRef(null);

  useEffect(() => {
    if (isStandalone()) return;

    const onPrompt = (e) => {
      e.preventDefault();
      deferred.current = e;
      if (sessionStorage.getItem("installNudged")) return;
      sessionStorage.setItem("installNudged", "1");
      toast("Install Old Geezer", {
        description: "Add the app to your home screen — one tap, no browser bars.",
        duration: 12000,
        action: {
          label: "Install",
          onClick: async () => {
            const ev = deferred.current;
            if (!ev) return;
            ev.prompt();
            await ev.userChoice;
            deferred.current = null;
          },
        },
      });
    };

    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  return null;
};
